import React from 'react';
import { Box, Grid, TextField, InputAdornment, Select, MenuItem } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

const TYPE_OPTIONS = [
    { value: 'release', label: 'Release' },
    { value: 'announcement', label: 'Announcement' },
    { value: 'system_alert', label: 'System Alert' }
];

const STATUS_OPTIONS = [
    { value: 'all', label: 'All Status' },
    { value: 'read', label: 'Read' },
    { value: 'unread', label: 'Unread' }
];

const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' }
];


const NotificationToolbar = ({ searchValue, onSearchChange, typeFilter, onTypeFilterChange, statusFilter, onStatusFilterChange, sortOrder, onSortOrderChange, onClearFilters }) => (
    <Box className="notification-page-toolbar">
        <Grid container columnSpacing={1.5} rowSpacing={1} alignItems="center">
            <Grid size={{ xs: 12, md: 'grow' }} sx={{ minWidth: 0 }}>
                <TextField
                    fullWidth
                    size="small"
                    value={searchValue}
                    onChange={(event) => onSearchChange(event.target.value)}
                    placeholder="Search notifications..."
                    slotProps={{ input: { startAdornment: <InputAdornment position="start"><SearchRoundedIcon /></InputAdornment> } }}
                    className="notification-page-search-field"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 'auto' }}>
                <Select size="small" value={typeFilter} onChange={(event) => onTypeFilterChange(event.target.value)} className="notification-page-filter-select">
                    <MenuItem value="all">All Types</MenuItem>
                    {TYPE_OPTIONS.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 'auto' }}>
                <Select size="small" value={statusFilter} onChange={(event) => onStatusFilterChange(event.target.value)} className="notification-page-filter-select">
                    {STATUS_OPTIONS.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 'auto' }}>
                <Select size="small" value={sortOrder} onChange={(event) => onSortOrderChange(event.target.value)} className="notification-page-filter-select">
                    {SORT_OPTIONS.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 'auto' }}>
                <Box component="button" type="button" className="notification-page-clear-filters" onClick={onClearFilters}>Clear filters</Box>
            </Grid>
        </Grid>
    </Box>
);

export default NotificationToolbar;